import { render, staticRenderFns } from "./previewBox.vue?vue&type=template&id=5c0a0c4c&scoped=true&"
import script from "./previewBox.vue?vue&type=script&lang=js&"
export * from "./previewBox.vue?vue&type=script&lang=js&"
import style0 from "./previewBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./previewBox.vue?vue&type=style&index=1&id=5c0a0c4c&lang=less&scoped=true&"
import style2 from "./previewBox.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0a0c4c",
  null
  
)

component.options.__file = "previewBox.vue"
export default component.exports